import { useEffect } from 'react';

import { useLocaleWrapper } from '../contexts/LocaleContextProvider';

const useHtmlLocale = () => {
  const { locale } = useLocaleWrapper('useHtmlLocale');
  useEffect(() => {
    document.documentElement.setAttribute('lang', locale.code);
  }, [locale]);
};

export default useHtmlLocale;
